enum RecordType {
  None = 'none',
  Video = 'video',
  VideoLive = 'video-live',
  VideoAsync = 'video-async',
  GIF = 'gif'
}

export default RecordType;



// WEBPACK FOOTER //
// ./src/data/RecordType.ts